import Sortable from 'sortablejs'

export default {
  inserted: function (el, binding) {
    return new Sortable(el, binding.value || {})
  },
}
